var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateLeadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5018",
    "data-name": "Group 5018",
    transform: "translate(-98 -152)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(98 152)",
    fill: "#035aa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_204_-_Outline",
    "data-name": "Ellipse 204 - Outline",
    d: "M15,.3A14.7,14.7,0,0,0,4.606,25.394,14.7,14.7,0,1,0,25.394,4.606,14.6,14.6,0,0,0,15,.3M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(98 152)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10033",
    "data-name": "Path 10033",
    d: "M1.216-11.28h4.16a5.92,5.92,0,0,1,4.3,1.48A5.512,5.512,0,0,1,11.2-5.648a5.539,5.539,0,0,1-1.528,4.16A5.9,5.9,0,0,1,5.376,0H1.216Zm4.032,9.6q3.888,0,3.888-3.968Q9.136-9.6,5.248-9.6H3.28v7.92Z",
    transform: "translate(108 173)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateLeadsIcon);
export default __webpack_public_path__ + "static/media/duplicate-leads-icon.6ba6cc1625aa4d133b39afa7b2794d9f.svg";
export { ForwardRef as ReactComponent };